import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ApiEntryControlService } from 'src/app/modules/entry-control/api-entry-control.service';
import { TaskExecution } from 'src/app/modules/entry-control/interfaces/tasks';

@Component({
  selector: 'app-view-task-execution',
  templateUrl: './view-task-execution.component.html',
  styleUrls: ['./view-task-execution.component.css']
})
export class ViewTaskExecutionComponent implements OnInit, OnChanges {
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService
  ) { }

  @Input()
  dataId: number | string = 0;

  execution: TaskExecution | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (Number(this.dataId) > 0) {
      this.get(this.dataId);
    }
  }
  ngOnInit(): void {
    if (Number(this.dataId) > 0) {
      this.get(this.dataId);
    }
  }

  get(id: number | string) {
    this.execution = null;
    this.api.getTaskExecution(id).subscribe(
      (response) => {
        this.execution = response.data as TaskExecution;
      },
      (error) => {
        this.toast.warning(error.error.mistakes, error.error.msg);
      }
    );
  }
}
